import React from 'react';
import {NavLink} from 'react-router-dom';
import accountCircle from 'modules/MainMenu/assets/account_circle-24px.svg';
import document from 'modules/MainMenu/assets/document.svg';
import {pathnames as P} from 'common/constants/pathnames';
import styles from './styles.module.scss';
import PrivacyPolicyPopup from "../../../../common/components/PrivacyPolicyPopup";

const UserCardView = ({
                        name,
                        family_name,
                        email
                      }) => (
  <div className={styles.userCardContainer}>
    <img src={accountCircle} alt="account" className={styles.accountIcon}/>
    <div className={styles.name}>{name} {family_name}</div>
    <div className={styles.email}>{email}</div>
    <div className={styles.divider}/>
    <div className={styles.menu}>
      <div className={styles.menuItem}>
        <PrivacyPolicyPopup
          label={(
            <div className={styles.menuItemLabel}>
              <img src={document} alt="document" className={styles.icon}/>
              <div className={styles.label}>תנאי שימוש ומדיניות פרטיות</div>
            </div>
          )}
          showCheckbox={false}
        />

      </div>
    </div>
    <div className={styles.divider}/>
    <NavLink
      className={styles.btnLogout}
      to={P.AUTH_LOGOUT}
    >
      התנתק
    </NavLink>
  </div>
);

UserCardView.propTypes = {};

export default UserCardView;
